import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import { formatMatchType } from "./matchDisplay";

/**
 * "Competing on" details shared by the Active Matches and Searching Posts
 * tables: the song (karaoke/dance), challenge or contest being competed on,
 * the category, and a group-duet marker with its target type.
 *
 * @param {Object} props
 * @param {{ title: string, artist?: string }|null} [props.song]
 * @param {string|null} [props.challenge]
 * @param {string|null} [props.contest]
 * @param {number|null} [props.missionNumber] - contest series mission
 * @param {string|null} [props.category]
 * @param {boolean} [props.isGroupDuet]
 * @param {string|null} [props.groupDuetTargetType] - KARAOKE | DANCE | CHALLENGE
 */
const CompetingOnCell = ({
  song,
  challenge,
  contest,
  missionNumber,
  category,
  isGroupDuet,
  groupDuetTargetType,
}) => {
  let label = null;
  let value = null;
  if (song?.title) {
    label = "Song";
    value = song.artist ? `${song.title} · ${song.artist}` : song.title;
  } else if (challenge) {
    label = "Challenge";
    value = challenge;
  } else if (contest) {
    label = "Contest";
    value =
      missionNumber !== null && missionNumber !== undefined
        ? `${contest} · Mission ${missionNumber}`
        : contest;
  }

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0 }}>
      {value ? (
        <Typography component="span" sx={{ fontSize: "13px", lineHeight: 1.3 }}>
          <Typography
            component="span"
            sx={{ fontSize: "11px", color: "#888", marginRight: "4px" }}
          >
            {label}:
          </Typography>
          <Typography component="span" sx={{ fontWeight: 600, fontSize: "13px" }}>
            {value}
          </Typography>
        </Typography>
      ) : (
        <Typography component="span" sx={{ fontSize: "13px", color: "#999" }}>
          {category ? "Category only" : "—"}
        </Typography>
      )}
      <Box sx={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
        {category && (
          <Typography component="span" sx={{ fontSize: "11px", color: "#666" }}>
            {category}
          </Typography>
        )}
        {isGroupDuet && (
          <Chip
            size="small"
            label={
              groupDuetTargetType
                ? `Group duet · ${formatMatchType(groupDuetTargetType)}`
                : "Group duet"
            }
            sx={{
              height: "18px",
              fontSize: "10px",
              fontWeight: 600,
              backgroundColor: "#e8eaf6",
              color: "#283593",
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default CompetingOnCell;
